import React from "react"
import { Anchor } from "@mantine/core"

import { Icon, Select } from "@/components"
import { useStyles } from "@/components/SelectWithLink/SelectWithLink.styles"

type SelectWithLinkProps = {
    name: string
    label: string
    tooltip?: string
    data: string[]
    linkText: string
    onLinkClick?: () => void
}

export const SelectWithLink = ({ name, label, tooltip, data, linkText, onLinkClick }: SelectWithLinkProps) => {
    const { classes } = useStyles()

    return (
        <div className={classes.container}>
            <Select name={name} label={label} tooltip={tooltip} data={data} />

            <Anchor className={classes.link} component="button" type="button" onClick={onLinkClick}>
                {linkText}
                <Icon icon="arrow-right" />
            </Anchor>
        </div>
    )
}
